// Info Section Form Functionality
class InfoSection {
    constructor() {
        this.form = document.querySelector('.info-section__right-content__form');
        this.formButtonContainer = this.form?.querySelector('.info-section__form-button-container');
        this.submitButton = this.formButtonContainer?.querySelector('.info-section__right-content__button');

        this.requiredFields = [
            'company',
            'store_name',
            'company_address',
            'full_name',
            'title_designation',
            'contact_number',
            'email_address',
            'type_of_inquiry',
            'product_of_interest',
            'quantity_of_interest'
        ];

        this.errorToFieldMap = {
            'company': "Enter company name",
            'store_name': "Enter store name",
            'company_address': "Enter company address",
            'full_name': "Enter full name",
            'title_designation': "Enter title/designation",
            'contact_number': "Enter valid contact number",
            'email_address': "Enter valid email address",
            'type_of_inquiry': "Select type of inquiry",
            'product_of_interest': "Select product of interest",
            'quantity_of_interest': "Select quantity of interest",
        };

        this.init();
    }

    init() {
        if (!this.form) return;

        // Prevent form submission on Enter key
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
        });

        this.submitButton.addEventListener('click', (e) => this.handleSubmit(e));
        // Real-time validation for better UX
        this.setupRealTimeValidation();
    }

    validateForm(formData) {
        const errors = [];

        this.requiredFields.forEach(field => {
            const value = formData.get(field);
            if (!value || value.trim() === '') {
                const errorMessage = this.errorToFieldMap[field];
                errors.push(errorMessage);
            }
        });

        // Email validation for contact number (assuming it might be email)
        const contactNumber = formData.get('contact_number');
        if (contactNumber && !this.isValidContact(contactNumber)) {
            errors.push('Please enter a valid contact number');
        }

        return errors;
    }

    isValidContact(contact) {
        // Check if it's a valid email or phone number
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Accepts all valid email addresses
        const phoneRegex = /^[\+]?[0-9][\d]{0,15}$/; // Accepts international numbers from all countries

        return emailRegex.test(contact) || phoneRegex.test(contact.replace(/[\s\-\(\)]/g, '')); // +639123456789
    }

    showErrors(errors) {
        // Remove existing error messages
        this.clearMessages('.form-error');

        // Add new error messages
        errors.forEach(error => {
            // Try to match error to specific field
            const fieldName = this.getFieldNameFromError(error);

            if (fieldName) {
                // Show field-specific error
                this.showFieldError(fieldName, error);
            } else {
                // Show general error at bottom of form
                const errorDiv = document.createElement('div');
                errorDiv.className = 'form-error';
                errorDiv.style.color = '#ff0000';
                errorDiv.style.margin = '0 0 12px 0';
                errorDiv.style.textAlign = 'center';
                errorDiv.style.fontSize = '9px';
                errorDiv.textContent = error;

                this.formButtonContainer.insertBefore(errorDiv, this.submitButton);
            }
        });
    }

    getFieldNameFromError(error) {
        // Map error messages to field names

        const errorToFieldMap = {
            'Enter company name': 'company',
            'Enter store name': 'store_name',
            'Enter company address': 'company_address',
            'Enter full name': 'full_name',
            'Enter title/designation': 'title_designation',
            'Enter valid contact number': 'contact_number',
            'Enter valid email address': 'email_address',
            'Select type of inquiry': 'type_of_inquiry',
            'Select product of interest': 'product_of_interest',
            'Select quantity of interest': 'quantity_of_interest',
        };

        return errorToFieldMap[error] || null;
    }

    showSuccess() {
        // Show the success modal
        const successModal = document.querySelector('.info-section-modal-success');
        if (successModal) {
            successModal.style.display = 'flex';

            // Add event listener for close button
            const closeButton = successModal.querySelector('.info-section-modal-success-header-button');
            if (closeButton) {
                closeButton.addEventListener('click', () => {
                    this.hideSuccessModal();
                });
            }

            // Add event listener to close modal when clicking outside
            successModal.addEventListener('click', (e) => {
                if (e.target === successModal) {
                    this.hideSuccessModal();
                }
            });
        }

        // Clear all field errors when showing success
        this.clearAllFieldErrors();
    }

    hideSuccessModal() {
        const successModal = document.querySelector('.info-section-modal-success');
        if (successModal) {
            successModal.style.display = 'none';
        }
    }

    setLoadingState(isLoading) {
        if (!this.submitButton) return;

        if (isLoading) {
            this.submitButton.disabled = true;
            this.submitButton.textContent = 'Submitting...';
            this.submitButton.style.opacity = '0.7';
        } else {
            this.submitButton.disabled = false;
            this.submitButton.textContent = 'Submit';
            this.submitButton.style.opacity = '1';
        }
    }

    clearMessages(selector) {
        const existingMessages = this.form.querySelectorAll(selector);
        existingMessages.forEach(msg => msg.remove());
    }

    clearAllMessages() {
        this.clearMessages('.form-error, .form-success');
        this.clearAllFieldErrors();
    }

    async handleSubmit(e) {
        e.stopPropagation();
        e.preventDefault();


        // Remove existing messages
        this.clearAllMessages();

        const formData = new FormData(this.form);

        // Validate form
        const errors = this.validateForm(formData);
        if (errors.length > 0) {
            this.showErrors(errors);
            return;
        }

        // Set loading state
        this.setLoadingState(true);

        try {

            const apiUrl = this.form.querySelector('input[name="api-url"]').value;
            const clientId = this.form.querySelector('input[name="client-id"]').value;
            const apiKey = this.form.querySelector('input[name="api-key"]').value;
            const fullUrl = `${apiUrl}?client_id=${clientId}`;

            const payload = {
                data: {
                    company_name: formData.get('company'),
                    store_name: formData.get('store_name'),
                    company_address: formData.get('company_address'),
                    full_name: formData.get('full_name'),
                    title: formData.get('title_designation'),
                    contact_no: formData.get('contact_number'),
                    email_address: formData.get('email_address'),
                    inquiry: formData.get('type_of_inquiry'),
                    product_interest: formData.get('product_of_interest'),
                    quantity_interest: formData.get('quantity_of_interest'),
                }
            };


            const response = await fetch(fullUrl, {
                method: 'POST',
                body: JSON.stringify(payload),
                headers: {
                    "oassis-api-key": apiKey,
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // Simulate API call delay
            await new Promise(resolve => setTimeout(resolve, 1500));

            // For demonstration, we'll always show success
            // In a real implementation, you'd check the response status
            this.showSuccess();

            // Reset form
            this.form.reset();

            // Trigger custom event
            document.dispatchEvent(new CustomEvent('infoSectionFormSubmitted', {
                detail: { formData: Object.fromEntries(formData) }
            }));

        } catch (error) {
            console.error('Form submission error:', error);
            this.showErrors(['There was an error submitting your form. Please try again.']);
        } finally {
            this.setLoadingState(false);
        }
    }

    setupRealTimeValidation() {
        const inputs = this.form.querySelectorAll('input, select');

        inputs.forEach(input => {
            input.addEventListener('blur', (e) => this.handleFieldBlur(e));
            input.addEventListener('input', (e) => this.handleFieldInput(e));
        });
    }

    handleFieldBlur(e) {
        const fieldName = e.target.name;
        const value = e.target.value.trim();

        // Remove existing field-specific error
        this.clearFieldError(fieldName);

        // Validate specific fields
        if (fieldName === 'contact_number' && value && !this.isValidContact(value)) {
            this.showFieldError(fieldName, 'Please enter a valid contact number');
        }
    }

    handleFieldInput(e) {
        // Remove field-specific error when user starts typing
        this.clearFieldError(e.target.name);
    }

    showFieldError(fieldName, message) {
        const field = this.form.querySelector(`.input-container[name="${fieldName}"]`);
        if (field) {
            const errorDiv = field.querySelector('.field-error');
            const input = this.form.querySelector(`input[name="${fieldName}"]`);
            const select = this.form.querySelector(`select[name="${fieldName}"]`);
            const inputField = input || select;

            if (inputField) {
                inputField.classList.add('error');
            }
            if (errorDiv) {
                errorDiv.textContent = message;
                errorDiv.classList.add('show');
            }
        }
    }

    clearFieldError(fieldName) {
        const field = this.form.querySelector(`.input-container[name="${fieldName}"]`);
        if (field) {
            const errorDiv = field.querySelector('.field-error');
            const input = this.form.querySelector(`input[name="${fieldName}"]`);
            const select = this.form.querySelector(`select[name="${fieldName}"]`);
            const inputField = input || select;

            if (inputField) {
                inputField.classList.remove('error');
            }
            if (errorDiv) {
                errorDiv.classList.remove('show');
            }
        }
    }

    clearAllFieldErrors() {
        const allFieldErrors = this.form.querySelectorAll('.field-error');
        allFieldErrors.forEach(error => error.classList.remove('show'));
    }

    // Method to reset form state (useful for testing)
    reset() {
        this.form.reset();
        this.clearAllMessages();
        this.setLoadingState(false);
    }

    // Method to validate form without submitting (useful for external validation)
    validate() {
        const formData = new FormData(this.form);
        return this.validateForm(formData);
    }

    // Method to get form data as object
    getFormData() {
        const formData = new FormData(this.form);
        return Object.fromEntries(formData);
    }
}

// Initialize form when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    new InfoSection();
});

// Make form globally accessible
window.InfoSection = InfoSection;